import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation solid />

      <section className="pt-28 sm:pt-36 pb-16 sm:pb-24 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto prose prose-stone">
          <h1 className="text-3xl sm:text-4xl font-serif text-gray-800 mb-8">Impressum</h1>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">Angaben gemäß § 5 TMG</h2>
          <p className="text-gray-600 leading-relaxed">
            Hotel Alpenhof Gauting<br />
            Unterbrunner Straße 9<br />
            82131 Gauting bei München
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">Vertreten durch</h2>
          <p className="text-gray-600 leading-relaxed">
            Frau Anette Bäuerle
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">Kontakt</h2>
          <p className="text-gray-600 leading-relaxed">
            Telefon: +49 (0) 89 85 64 29 10<br />
            E-Mail: <a href="mailto:hotel@alpenhof-gauting.de" className="text-amber-700 hover:underline">hotel@alpenhof-gauting.de</a>
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">Umsatzsteuer-ID</h2>
          <p className="text-gray-600 leading-relaxed">
            DE 301 111 726
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">Registereintrag</h2>
          <p className="text-gray-600 leading-relaxed">
            Amtsgericht München<br />
            HRB 220099<br />
            Finanzamt Fürstenfeldbruck
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">Genehmigungsbehörde</h2>
          <p className="text-gray-600 leading-relaxed">
            Landratsamt Starnberg
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p className="text-gray-600 leading-relaxed">
            Frau Anette Bäuerle<br />
            Hotel Alpenhof Gauting<br />
            Unterbrunner Straße 9<br />
            82131 Gauting bei München
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">Haftungsausschluss</h2>
          <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">Haftung für Inhalte</h3>
          <p className="text-gray-600 leading-relaxed">
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>

          <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">Haftung für Links</h3>
          <p className="text-gray-600 leading-relaxed">
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>

          <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">Urheberrecht</h3>
          <p className="text-gray-600 leading-relaxed">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
